import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, catchError, map, Observable, of, throwError } from 'rxjs';
import { Constant } from './Constant';
import { Privileges } from '../enums/privileges.enum';
import { ApiService } from '../api/api.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  SERVER_URL = environment.serverUrl;

  constructor(
    private apiService: ApiService,
    private router: Router, public dialog: MatDialog,
  ) { }



  public userSubject = new BehaviorSubject<any | null>(this.getUser());
  user$ = this.userSubject.asObservable();
  isUserSignedIn$ = this.user$.pipe(map(user => !!user));


  isAuthenticated(): boolean {
    return this.getToken() !== null;
  }

  isTempAuthenticated(): boolean {
    const tempToken = localStorage.getItem(Constant.TEMP_LOGGED_IN_USER);
    return !!tempToken;
  }


  login(context: any, remember: boolean): Observable<any> {
    return this.apiService.post("/auth/login", context).pipe(
      map((response: any) => {
        if (response.success === true) {
          localStorage.setItem("loginStatus", "SUCCESS");
        }
        return response;
      }),
      catchError((error) => {
        return throwError(() => new Error(error.message));
      })
    );
  }


  get isLoggedIn(): boolean {
    return !!localStorage.getItem(Constant.USER_DATA);
  }

  getToken(): string | null {
    return localStorage.getItem(Constant.LOGGED_IN_USER);
  }

  getTempToken(): string | null {
    return localStorage.getItem(Constant.TEMP_LOGGED_IN_USER);
  }


  getUser(): any | null {
    if (!this.isLoggedIn) return null;
    const userData = localStorage.getItem(Constant.USER_DATA);
    return userData ? JSON.parse(userData) : null;
  }

  getPermissions(): string[] {
    const user = this.getUser();
    if (!user?.permissions) return [];
    return user.permissions.map((value: string) => value.trim());
  }

  getAccount(): any | null {
    return this.getUser()?.account ?? null;
  }

  getEmail(): string | null {
    return this.getUser()?.email ?? null;
  }

  getDisplayName(): string | null {
    return this.getUser()?.displayName ?? null;
  }

  getPhoneNumber(): string | null {
    return this.getUser()?.phoneNumber ?? null;
  }

  getRole(): string | null {
    return this.getUser()?.role ?? null;
  }

  getId(): string | null {
    return this.getUser()?.id ?? null;
  }

  hasRole(role: string): boolean {
    return this.getPermissions().includes(role);
  }

  hasAnyPermission(permissions: string[]): boolean {
    return permissions.some((permission) => this.hasRole(permission));
  }

  forbidAccess(): void {
    this.router.navigate(["/forbidden"]);
  }

  logout(redirect: boolean = true): void {
    localStorage.removeItem(Constant.USER_DATA);
    localStorage.removeItem(Constant.LOGGED_IN_USER);
    this.userSubject.next(null);
    if (redirect) {
      this.router.navigate(["/login"]);
    }
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  getLgaName() {
    return this.getUser()?.lga ?? null;
  }


  
}
